import { observer } from 'mobx-react';
import { SearchParameters } from '../../../../ListFilter/Types';
import GenericSortFilter from '../../../GenericSortFilter';
import LearningCollectionsStore from '../../Store';
import { sortFilterSelectOptions } from '../../Types';

interface Props {
  store: LearningCollectionsStore;
  sortParameters: SearchParameters;
}

function LearningCollectionSort({ store, sortParameters }: Props) {
  return (
    <GenericSortFilter
      labelText="Sort by"
      options={sortFilterSelectOptions}
      width="w-48"
      parameters={sortParameters}
      updatingParameters={store.updatingSortParameters}
      sortFilterKey={'sort'}
    />
  );
}

export default observer(LearningCollectionSort);
